import { type AuditChecklistForm } from '#packages/data-collection/models/audit-checklist-form';

import { type ExcelSheetMapping } from '../types/excel-mapping';

/**
 * Maps Checklist form fields to Excel named ranges in the "3. Checklist" sheet.
 *
 * All fields are boolean toggles rendered as Yes / No in the workbook.
 */
export const checklistSheetMapping: ExcelSheetMapping<AuditChecklistForm> = {
  label: 'Checklist',

  fields: [
    {
      rangeName: 'checklist_visited_every_room',
      getValue: (d) => d.isEveryRoomChecked,
    },
    {
      rangeName: 'checklist_fill_out_background_tab',
      getValue: (d) => d.isEveryFormFilled,
    },
    {
      rangeName: 'checklist_rooftop_accessible',
      getValue: (d) => d.hasRooftopPhotos,
    },
    {
      rangeName: 'checklist_outside_building_image',
      getValue: (d) => d.hasBuildingSidePhotos,
    },
    {
      rangeName: 'checklist_door_window_image',
      getValue: (d) => d.hasDoorsAndWindowsPhotos,
    },
    {
      rangeName: 'checklist_bas_interface',
      getValue: (d) => d.hasBASInterfacePhotos,
    },
    {
      rangeName: 'checklist_thermal_image',
      getValue: (d) => d.hasEnvelopeThermalImages,
    },
  ],
};
